import * as React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import LoginContainer from "../../containers/Login";
import MyPageContainer from "../../containers/MyPage";
import VerifyCodeContainer from "../../containers/VerifyCode";
import RegisterPaidContainer from "../../containers/RegisterPaid";
import * as aa from "../../generated/UserAPIAgent";

import { URL_PATHS } from "../../routes";
import PrivateRoute from "./PrivateRoute";
import PaymentCancel from "../../containers/PaymentCancel";
import PaymentCancelFinish from "../../containers/PaymentCancelFinish";
import PaymentInfo from "../../containers/PaymentInfo";
import PaymentMake from "../../containers/PaymentMake";
import PaymentMake3DS from "../../containers/PaymentMake3DS";
import PaymentMakeFinish from "../../containers/PaymentMakeFinish";
import PaymentPlan from "../../containers/PaymentPlan";
import CreditCardInfoChangeFinish from "../../containers/CreditCardInfoChangeFinish";
import PaymentSystemChange from "../../containers/PaymentSystemChangeInfo";
import ConfirmTransition from "../../containers/ConfirmTransition";
import TransitionFinish from "../../containers/TransitionFinish";
import TransitionCancel from "../../containers/TransitionCancel";
import TransitionCancelFinish from "../../containers/TransitionCancelFinish";
import PaymentRestartConfirm from "../../containers/PaymentRestartConfirm";
import PaymentRestartFinish from "../../containers/PaymentRestartFinish";
import Logout from "../../containers/Logout";
import Analytics from "../Analytics";
import ActiveUserRoute from "./ActiveUserRoute";
import PaymentMakeRoute from "./PaymentMakeRoute";
import RegisterPaidRoute from "./RegisterPaidRoute";
import IncompleteRegisterContainer from "../../containers/IncompleteRegister";
import CancelSubscriptionProcedure from "../../containers/CancelSubscriptionProcedure";
import EmailUnsubscribe from "../../pages/EmailUnsubscribe";
import InstallAppContainer from "../../containers/InstallApp";
import LoginRoute from "./LoginRoute";
import SubscriptionChangeFinish from "../../containers/SubscriptionChangeFinish";
import ContractPaidMember from "../../containers/ContractPaidMember";
import WithdrawalApply from "../../containers/WithdrawalApply";
import WithdrawalApplyFinish from "../../containers/WithdrawalApplyFinish";

interface RoutesProps {
    user: aa.User | null;
    shouldRegister: boolean;
}
export const Routes = (props: RoutesProps) => {
    return (
        <Router>
            <Analytics>
                <Switch>
                    <Route exact path={URL_PATHS.emailUnsubscribe()}>
                        <EmailUnsubscribe />
                    </Route>
                    <RegisterPaidRoute
                        user={props.user}
                        shouldRegister={props.shouldRegister}
                        exact
                        path={URL_PATHS.registerPaid()}
                    >
                        <RegisterPaidContainer />
                    </RegisterPaidRoute>
                    <LoginRoute
                        exact
                        path={URL_PATHS.login()}
                        shouldRegister={props.shouldRegister}
                    >
                        <LoginContainer />
                    </LoginRoute>
                    <Route exact path={URL_PATHS.verifyCode()}>
                        <VerifyCodeContainer />
                    </Route>
                    <Route exact path={URL_PATHS.logout()}>
                        <Logout />
                    </Route>
                    <PrivateRoute
                        user={props.user}
                        exact
                        path={URL_PATHS.myPage()}
                    >
                        <MyPageContainer />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.paymentCancel()}
                        user={props.user}
                    >
                        <PaymentCancel />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.paymentCancelFinish()}
                        user={props.user}
                    >
                        <PaymentCancelFinish />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.paymentInfo()}
                        user={props.user}
                    >
                        <PaymentInfo />
                    </PrivateRoute>
                    <PaymentMakeRoute
                        exact
                        path={URL_PATHS.paymentMake()}
                        user={props.user}
                    >
                        <PaymentMake />
                    </PaymentMakeRoute>
                    <PaymentMakeRoute
                        exact
                        path={URL_PATHS.paymentMake3DS()}
                        user={props.user}
                    >
                        <PaymentMake3DS />
                    </PaymentMakeRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.paymentMakeFinish()}
                        user={props.user}
                    >
                        <PaymentMakeFinish />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.subscriptionChangeFinish()}
                        user={props.user}
                    >
                        <SubscriptionChangeFinish />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.creditCardInfoChangeFinish()}
                        user={props.user}
                    >
                        <CreditCardInfoChangeFinish />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.paymentPlan()}
                        user={props.user}
                    >
                        <PaymentPlan />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.paymentSystemChange()}
                        user={props.user}
                    >
                        <PaymentSystemChange />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.confirmTransition()}
                        user={props.user}
                    >
                        <ConfirmTransition />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.transitionFinish()}
                        user={props.user}
                    >
                        <TransitionFinish />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.transitionCancel()}
                        user={props.user}
                    >
                        <TransitionCancel />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.transitionCancelFinish()}
                        user={props.user}
                    >
                        <TransitionCancelFinish />
                    </ActiveUserRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.paymentRestartConfirm()}
                        user={props.user}
                    >
                        <PaymentRestartConfirm />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.paymentRestartFinish()}
                        user={props.user}
                    >
                        <PaymentRestartFinish />
                    </PrivateRoute>
                    <ActiveUserRoute
                        exact
                        // TODO: duplicate?
                        path={URL_PATHS.paymentSystemChangeInfo()}
                        user={props.user}
                    >
                        <PaymentSystemChange />
                    </ActiveUserRoute>
                    <ActiveUserRoute
                        exact
                        path={URL_PATHS.cancelSubscriptionProcedure()}
                        user={props.user}
                    >
                        <CancelSubscriptionProcedure />
                    </ActiveUserRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.incompleteRegister()}
                        user={props.user}
                    >
                        <IncompleteRegisterContainer />
                    </PrivateRoute>
                    <Route exact path={URL_PATHS.installApp()}>
                        <InstallAppContainer />
                    </Route>
                    <PrivateRoute
                        user={props.user}
                        exact
                        path={URL_PATHS.contractPaidMember()}
                    >
                        <ContractPaidMember />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.withdrawalApply()}
                        user={props.user}
                    >
                        <WithdrawalApply />
                    </PrivateRoute>
                    <PrivateRoute
                        exact
                        path={URL_PATHS.withdrawalApplyFinish()}
                        user={props.user}
                    >
                        <WithdrawalApplyFinish />
                    </PrivateRoute>
                    <Redirect to={URL_PATHS.myPage()} />
                </Switch>
            </Analytics>
        </Router>
    );
};
